import { render, staticRenderFns } from "./taketest.vue?vue&type=template&id=707d4b8c&scoped=true"
import script from "./taketest.vue?vue&type=script&lang=js"
export * from "./taketest.vue?vue&type=script&lang=js"
import style0 from "./taketest.vue?vue&type=style&index=0&id=707d4b8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d4b8c",
  null
  
)

export default component.exports